import React, { createContext, useContext } from 'react';
import InboxService from '../inbox.service';

const InboxServiceContext = createContext();

export const InboxServiceProvider = ({ children }) => {
  return (
    <InboxServiceContext.Provider value={InboxService}>
      {children}
    </InboxServiceContext.Provider>
  );
};

export const useInboxService = () => {
  const context = useContext(InboxServiceContext);
  if (context === undefined) {
    throw new Error('useInboxService must be used within a InboxServiceProvider');
  }
  return context;
};

export default InboxServiceContext;
